/**
 * 底部提示位只表达「在等模型」，与工具芯片互斥：
 * 芯片负责工具执行（含导入草稿 / 映射 / 写入的进行中子阶段）；
 * 底部只出现「正在连接模型…」「正在规划下一步…」或「正在整理较早的对话记忆…」。
 */
export type AssistantTrailingHint = 'connecting' | 'planning' | 'compressing' | null

export function resolveAssistantTrailingHint(input: {
  streaming: boolean
  hasVisibleTimeline: boolean
  lastKind?: string
  lastToolPending?: boolean
  awaitingNext?: boolean | null
  compressing?: boolean | null
}): AssistantTrailingHint {
  if (!input.streaming) {
    return null
  }
  // 上下文压缩（85% 触发的一次性总结调用）：数秒暂停窗口，优先于一切等待提示，
  // 让用户明确知道系统在整理历史而不是卡死。
  if (input.compressing) {
    return 'compressing'
  }
  if (!input.hasVisibleTimeline) {
    return 'connecting'
  }
  switch (input.lastKind) {
    case 'reasoning':
    case 'content':
      return input.awaitingNext ? 'planning' : null
    case 'question-single':
    case 'question-group':
      return null
    case 'tool-single':
      if (input.lastToolPending) {
        return null
      }
      return input.awaitingNext ? 'planning' : null
    default:
      return null
  }
}

/** 100% 表示导入工具已结束，芯片应回到完成态，不再跟子阶段文案。 */
export function isImportProgressComplete(progressPercent: unknown): boolean {
  return typeof progressPercent === 'number' && progressPercent >= 100
}
